import { createSyncAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';

const closeVisibleModalsAction = () =>
	createSyncAction(ActionTypes.CLOSE_VISIBLE_MODALS, undefined);

export default closeVisibleModalsAction;
